import React, { useState, useEffect, useCallback } from "react";
import { MContainer, MLink } from "../../element/Elemens";
import "../../assets/scss/_product.scss";
import { FiHeart } from "react-icons/fi";
import { BsEyeFill } from "react-icons/bs";
import { useSelector, useDispatch } from "react-redux";
import LoadingPage from "../../component/loading/page/LoadingPage";
import { fetchProducts } from "../../redux/actions/productActions";
import InfiniteScroll from "react-infinite-scroll-component";

const URL = process.env.REACT_APP_API_DOMAIN;

const Product = () => {
  const dispatch = useDispatch();

  const [filter, setFilter] = useState({
    page: 1,
    per_page: 20
  });

  const {
    list: products,
    loading,
    hasMore
  } = useSelector((state) => state.product);

  // 🔹 initial load
  useEffect(() => {
    dispatch(fetchProducts(filter));
  }, [dispatch]);

  // 🔹 load more (optimized)
  const fetchMore = useCallback(() => {
    setFilter((prev) => {
      const newFilter = { ...prev, page: prev.page + 1 };
      dispatch(fetchProducts(newFilter));
      return newFilter;
    });
  }, [dispatch]);

  // 🔹 image fallback
  const handleImageError = (e) => {
    e.target.src = "/no-image.png"; // public papkaga qo'y
  };

  return (
    <MContainer>
      <InfiniteScroll
        dataLength={products.length}
        next={fetchMore}
        hasMore={hasMore}
        loader={<LoadingPage />}
      >
        <div className="product__grid">
          {products.map((product) => (
            <div key={product.id} className="product__cart">
              {/* ❤️ Like */}
              <div className="product__cart__love">
                <FiHeart className="product__cart__love__icon" />
              </div>

              {/* 🖼 Image */}
              <MLink to={`/product/order/${product.id}`}>
                <div className="product__cart__image__ramci">
                  <img
                    src={`${URL}uploads/${product.main_image}`}
                    alt={product.title}
                    onError={handleImageError}
                    loading="lazy"
                  />
                </div>
              </MLink>

              {/* 📦 Body */}
              <div className="product__cart__body">
                <span className="product__cart__title">
                  {product.title?.slice(0, 40)}
                </span>

                <div className="cart__informasion__price__seen">
                  <span className="product__cart__price">
                    {product.price?.toLocaleString()} so'm
                  </span>

                  <span className="product__cart__most__seen">
                    <BsEyeFill />
                    {product.views || 0}
                  </span>
                </div>

                {/* 🛒 Button */}
                <MLink to={`/product/order/${product.id}`}>
                  <button className="product__cart__order__button">
                    Buyurtma berish
                  </button>
                </MLink>
              </div>
            </div>
          ))}
        </div>
      </InfiniteScroll>

      {loading && products.length === 0 && <LoadingPage />}
    </MContainer>
  );
};

export default Product;
